// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saltCalendarCarousel-track{grid-auto-flow:column;display:grid}.saltCalendarCarousel-track>*{width:100%;position:absolute;left:0}.saltCalendarCarousel-track>:nth-child(2){position:relative}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
